import { getApplication } from '@ms/yammer-libs-static-config';

import { useIsAskMeAnythingLoadedInTeamsQnaApp } from './selectors';

type UseIsStrictlyTeamsQna = () => boolean;
export const useIsStrictlyTeamsQna: UseIsStrictlyTeamsQna = () => {
  const isTeamsQnA = getApplication() === 'YAMMER_TEAMS_MEETING';
  const isAskMeAnythingLoadedInTeamsQna = useIsAskMeAnythingLoadedInTeamsQnaApp();

  return isTeamsQnA && !isAskMeAnythingLoadedInTeamsQna;
};
